define('plugin/google-reviews/view/GoogleReviewsListView',['require','marionette','plugin/google-reviews/view/GoogleReviewsItemView','lib/view/BaseCompositeView'],function (require) {

    var Marionette = require('marionette');
    var GoogleReviewsItemView = require('plugin/google-reviews/view/GoogleReviewsItemView');

    var Parent = require('lib/view/BaseCompositeView');

    /**
     * Google Reviews composite view
     *
     * @class GoogleReviewsListView
     */
    return Marionette.CollectionView.extend({
        childView: GoogleReviewsItemView,

        onRender: function() {
            // console.log('render', this);
            // console.log(this.collection);
        }

    });

});
